import * as React from "react";
import { observer } from "mobx-react";
import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import { FieldLabelWithHelp } from "./FieldHelpIcon";
import { useRootStore } from "../../../store/contexts";

type ShowMultiLineProps = {
  label: string;
  value: string | string[];
  helperText?: string;
  hidden?: boolean;
  description?: string;
};

// Campo de solo lectura: el borde se oculta con `transparent` y no
// pintandolo del color del fondo. Pintarlo de blanco funcionaba unicamente
// sobre fondo blanco; en modo oscuro dibujaba lineas blancas.
const CustomTextField = styled(TextField)`
   & label.Mui-focused {
     border-color: transparent
   },
   & .MuiInput-underline:after {
     border-color: transparent
   },
   & .MuiOutlinedInput-root {
     & fieldset {
       border-color: transparent
     },
     &:hover fieldset {
       border-color: transparent
     },
     &.Mui-focused fieldset {
       border-color: transparent
     },
   },
` as typeof TextField;

// Muestra una lista de valores apilados (uno por línea), sin truncar. Acepta un
// string[] o un string ya unido con "; " (convención de los campos *Display
// precomputados en el server). Cada ítem se resuelve al idioma activo.
export const ShowMultiLine: React.FC<ShowMultiLineProps> = observer(
  ({ label, value, helperText = "", hidden = false, description }) => {
    const { langStore } = useRootStore();
    if (hidden) return null;
    const items = (
      Array.isArray(value) ? value : String(value ?? "").split(/;\s+/)
    )
      .map((v) => langStore.displayIdByLang(v ?? ""))
      .filter((v) => v.length > 0);
    const displayValue = items.join("\n");
    return (
      <CustomTextField
        size={"small"}
        inputProps={{ readOnly: true }}
        variant={"outlined"}
        multiline
        helperText={helperText}
        sx={{ m: 1, mb: 1.5, width: 500 }}
        label={<FieldLabelWithHelp label={label} description={description} />}
        value={displayValue}
        InputLabelProps={description ? { shrink: true } : undefined}
      />
    );
  }
);
